export default __webpack_public_path__ + "static/media/character.8303b9224e84d465fa6a4694f1f245c8.png";